import { Button, Column, Row, Text } from '@atom-web/micros'
import { useMemo } from 'react'

import { filterPrices } from '../data'

export default ({ assetBg, bgSize, onClickPriceFilter }) => {
	const filterByPrice = useMemo(() => filterPrices, [])

	return (
		<Column
			gap={4}
			css={{
				position: 'relative',
				width: '100%',
				overflow: 'hidden',
				backgroundColor: '$white',
				borderRadius: '$1',
				backgroundClip: 'padding-box',
				boxShadow: '0 3px 15px rgb(0 0 0 / 10%)',
				minHeight: '200px',
				justifyContent: 'center',
				alignItems: 'center',
				marginBottom: '32px',
				textAlign: 'center',

				'@smMax': {
					boxShadow: 'none',
					padding: '8%',
				},

				'&::before': {
					position: 'absolute',
					content: '',
					bottom: 0,
					left: 0,
					width: '76.5px',
					height: '87px',
					background: assetBg,
					backgroundSize: bgSize,
					backgroundPosition: '-72px -96px',

					'@smMax': {
						display: 'none',
					},
				},

				'&::after': {
					position: 'absolute',
					content: '',
					bottom: 0,
					right: 0,
					width: '152px',
					height: '100.5px',
					background: assetBg,
					backgroundPosition: '-225px -96px',
					backgroundSize: bgSize,

					'@smMax': {
						display: 'none',
					},
				},
			}}
		>
			<Text
				css={{
					fontSize: '24px',
					fontWeight: '$bolder',
					lineHeight: '32px',
					letterSpacing: '-0.02em',
					color: '#444',

					'@smMax': {
						fontSize: '22px',
					},
				}}
			>
				What’s your budget per person for this trip?
			</Text>
			<Row
				gap={2}
				css={{
					'@smMax': {
						width: '100%',
						flexWrap: 'wrap',
						justifyContent: 'center',
						gap: '$3',
					},
				}}
			>
				{filterByPrice.map(({ text, route }, index) => (
					<Button
						key={'filter-btn-' + index}
						outlined
						size="md"
						onClick={() => onClickPriceFilter(route)}
						css={{
							color: '#1895b3',
							border: '1px solid #1895b3 !important',
							boxShadow: 'none',

							'&:hover': {
								opacity: 0.8,
							},
						}}
					>
						{text}
					</Button>
				))}
			</Row>
		</Column>
	)
}
